import Button from '@cashew/button';
import classNames from 'classnames';
import { set } from 'lodash';
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable operator-linebreak */
import React, { type ChangeEvent, useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Input, ModalConfirm } from '../../components';
import type { RootState } from '../../reducers';
import type { UserState } from '../../reducers/user';

const { api, priceFormat } = require('@cashew/utils');

export default ({
  orderDetails,
  showConfirmModal,
  setShowConfirmModal,
  dispatched,
  refundEligibilityDetails,
}: any) => {
  type Status = 'warning' | 'error' | 'info' | 'success' | 'none';
  const { t } = useTranslation();
  const params: any = useParams();
  const { role }: UserState = useSelector((state: RootState) => state.user);
  const [showResult, setShowResult] = useState(false);
  const [resultStatus, setResultStatus] = useState<Status>('none');
  const [refundLoading, setRefundLoading] = useState(false);
  const [refundAmount, setRefundAmount] = useState('');
  const [refundAmountApi, setRefundAmountApi] = useState('');
  const [refundError, setRefundError] = useState<any>();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState<boolean>(false);
  const [forceRender, setForceRender] = useState(1);
  const [showReverseModal, setShowReverseModal] = useState(false);

  const handleRefundAmountChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    let numericString = inputValue.replace(/[^\d.]/g, '');

    const parts = numericString.split('.');
    if (parts.length > 2) {
      numericString = `${parts[0]}.${parts.slice(1).join('')}`;
    }

    if (numericString.includes(' ')) {
      return;
    }

    if (
      numericString !== '' &&
      numericString !== '.' &&
      Number.isNaN(Number(numericString))
    ) {
      return;
    }

    if (numericString.split('.')[1]?.length > 2) {
      return;
    }

    setRefundAmount(numericString);
  };

  const formattedRefundInputValue = useMemo(() => {
    if (dispatched) {
      if (
        refundAmount === '' ||
        refundAmount === '.' ||
        refundAmount.endsWith('.')
      ) {
        return refundAmount;
      }

      return priceFormat({
        currency: orderDetails?.currencyCode,
        amount: +refundAmount || 0,
      });
    }

    return priceFormat({
      currency: orderDetails?.currencyCode,
      amount: orderDetails?.totalAmount ?? 0,
    });
  }, [dispatched, orderDetails, refundAmount]);

  const handleCheckboxChange = () => {
    if (orderDetails?.hasPurchaseFee) {
      setIsChecked(true);
    }
    setIsChecked(!isChecked);
  };

  useEffect(() => {
    if (Number(refundAmount) === Number(orderDetails.totalAmount)) {
      setIsCheckboxDisabled(false);
      setForceRender(forceRender + 1);
    } else {
      setIsCheckboxDisabled(true);
      setIsChecked(false);
      setForceRender(forceRender + 1);
    }

    if (Number(refundAmount) === Number(orderDetails?.balanceAmount)) {
      setIsCheckboxDisabled(false);
      setForceRender(forceRender + 1);
    }
  }, [
    Number(refundAmount),
    Number(orderDetails.totalAmount),
    Number(orderDetails?.balanceAmount),
  ]);

  const resultTitle =
    resultStatus === 'error'
      ? 'We encountered an issue'
      : `Order ${resultStatus === 'success' ? 'was' : 'was not'} refunded`;

  useEffect(() => {
    if (!dispatched) {
      setRefundAmountApi(orderDetails.totalAmount);
    }
  }, [dispatched, orderDetails]);

  const resultDescription =
    resultStatus === 'error' ? (
      <div className="resultDescriptionStatus">
        {' '}
        The order &nbsp;
        <span style={{ fontWeight: '800' }}>{orderDetails.id}</span>
        &nbsp; was not refunded, please reach out to our support by email at
        <br />
        <a
          style={{ color: '#fed01d' }}
          href="mailto:merchantsupport@cashewpayments.com"
        >
          <span style={{ fontWeight: '800' }}>
            merchantsupport@cashewpayments.com
          </span>
        </a>
        &nbsp; for assistance.
      </div>
    ) : (
      <>
        The order &nbsp;
        <span style={{ fontWeight: '800' }}>{orderDetails.id}</span>
        &nbsp;
        {resultStatus === 'success' ? 'was successfully' : 'was not'}
        &nbsp;refunded.
      </>
    );

  const isRefundAvailable = refundAmount <= orderDetails.balanceAmount;
  const confirmForm = (
    <div>
      {refundLoading && (
        <img className="loading-img" src="/loading.png" alt="Loading..." />
      )}
      <form className={refundLoading ? 'opacity-0' : ''}>
        <div className="form-row">
          <Input
            name="PriorRefunds"
            placeholder="Prior Refunds"
            value={priceFormat({
              currency: orderDetails.currencyCode,
              amount: Number(
                (orderDetails.totalAmount - orderDetails.balanceAmount).toFixed(
                  2
                )
              ),
            })}
            readonly
          />
          <div className="form-row-divider" />
          <Input
            name="grossOrderAmount"
            placeholder="Gross order total"
            value={priceFormat({
              currency: orderDetails.currencyCode,
              amount: orderDetails.totalAmount || 0,
            })}
            readonly
          />
        </div>
        <div className="form-row">
          <div className="input-hint">
            <Input
              error={!isRefundAvailable ? ' ' : undefined}
              name="shippingReference"
              placeholder="Refund amount"
              readonly={!dispatched}
              value={formattedRefundInputValue}
              maxLength={20}
              onChange={handleRefundAmountChange}
            />
            <span style={{ color: isRefundAvailable ? '#5ECC61' : '#ED3833' }}>
              {isRefundAvailable
                ? 'Enter refund amount to continue.'
                : "Refund amount can't exceed the net amount available"}
            </span>
          </div>
          <div className="form-row-divider" />
          <Input
            name="customerName"
            placeholder="Net amount available"
            value={priceFormat({
              currency: orderDetails.currencyCode,
              amount: orderDetails.balanceAmount,
            })}
            readonly
          />
        </div>

       
      </form>
    </div>
  );

  const onReverseConfirm = () => {
    setRefundLoading(true);
    api
      .post({
        endpoint: 'refunds',
        params: {
          orderId: params.orderId,
          refundAmount: dispatched ? refundAmount : refundAmountApi,
          cashewCustomerId: orderDetails.cashewCustomerId,
          storeId: orderDetails.storeId,
          purchaseFeeRefund: isChecked,
        },
      })
      .then(() => {
        setResultStatus('success');
        setRefundAmount('');
      })
      .catch((error: any) => {
        const errorCode = error?.response?.data?.errorCode;
        setResultStatus(errorCode === '400.005.017' ? 'warning' : 'error');
        if (errorCode) {
          setRefundError(errorCode);
        } else {
          setResultStatus('error');
        }
      })
      .finally(() => {
        setRefundLoading(false);
        setShowResult(true);
      });
  };

  const onRefund = () => {
    setRefundError('');

    if (refundEligibilityDetails?.totalPendingLPFIncludingVat > 0) {
      setShowReverseModal(true);
      setShowConfirmModal(false);
    } else {
      onReverseConfirm();
    }
  };

  const confirmButtons = (
    <div style={{ display: 'flex' }}>
      <Button
        extraClass="btn-black secondary"
        onClick={() => {
          setResultStatus('warning');
          setShowResult(true);
          setRefundAmount('');
        }}
      >
        Cancel
      </Button>
      <Button
        extraClass="order-details__confirm"
        disabled={
          (dispatched && refundAmount === '') ||
          (dispatched && Number(refundAmount) === 0) ||
          orderDetails.cashewCustomerId === null ||
          !isRefundAvailable ||
          role === 'CUSTOMER_CARE' ||
          refundLoading
        }
        loading={refundLoading}
        onClick={() => onRefund()}
      >
        {t('button.confirm')}
      </Button>
    </div>
  );
  const resultButtons = (
    <div>
      <Button
        extraClass="btn-blue"
        onClick={() => {
          setResultStatus('none');
          setRefundError('');
          setShowResult(false);
          setShowConfirmModal(false);
        }}
      >
        Ok
      </Button>
    </div>
  );

  return (
    <>
      {' '}
      {/* Restored React Fragment */}
      <ModalConfirm
        isVisible={showConfirmModal}
        onClose={() => {
          setShowConfirmModal(false);
          setRefundAmount('');
        }}
        showCloseButton={false}
        confirmTitle={`Request a refund for the order ${orderDetails.id}`}
        confirmDescription="Please review and confirm below"
        confirmForm={confirmForm}
        confirmButtons={confirmButtons}
        resultTitle={
          ['400.005.017', '400.005.020', '400.005.021'].includes(refundError)
            ? t(`refunds.error.title.${refundError}`)
            : resultTitle
        }
        resultDescriptionComponent={
          ['400.005.017', '400.005.020', '400.005.021'].includes(
            refundError
          ) ? (
            <div style={{ marginTop: 16 }}>
              {t(`refunds.error.description.${refundError}`)}
            </div>
          ) : (
            resultDescription
          )
        }
        resultButtons={resultButtons}
        showResult={showResult}
        resultStatus={resultStatus}
      />
      {/* Restored second ModalConfirm for reversing fees */}
      <ModalConfirm
        isVisible={showReverseModal}
        onClose={() => {
          setShowReverseModal(false);
          setRefundAmount('');
        }}
        showCloseButton={false}
        confirmTitle="Reverse Late Payment Fees?"
        confirmDescription={
          <>
            Please note that there's a total of{' '}
            <strong>
              {priceFormat({
                currency: orderDetails.currencyCode,
                amount:
                  refundEligibilityDetails?.totalPendingLPFIncludingVat || 0,
              })}
            </strong>{' '}
            of unpaid late payment fees applied for this order You'll have to
            reverse this amount before proceeding with the refund.
            <br />
            <br />
            Do you wish to reverse the applied fees and proceed with the refund?
          </>
        }
        confirmButtons={
          <>
            <Button
              extraClass="btn-black secondary"
              onClick={() => {
                setShowReverseModal(false);
                setRefundAmount('');
              }}
            >
              Cancel The Refund
            </Button>
            <Button
              extraClass="order-details__confirm"
              loading={refundLoading}
              onClick={onReverseConfirm}
            >
              Reverse The Fees
            </Button>
          </>
        }
        resultTitle={
          resultStatus === 'success'
            ? 'Order was refunded'
            : 'Could not process refund'
        }
        resultDescription={
          resultStatus === 'success'
            ? `The order ${orderDetails.id} was successfully refunded.`
            : `The order ${orderDetails.id} was not refunded.`
        }
        resultStatus={resultStatus}
        showResult={showResult}
        resultButtons={
          <Button
            extraClass="btn-blue"
            onClick={() => {
              setShowResult(false);
              setShowReverseModal(false);
              setRefundAmount('');

              window.location.reload();
            }}
          >
            Ok
          </Button>
        }
      />
    </>
  );
};
